/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface DatasetUpdateRequest
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_DatasetUpdateRequest_name")("string")(() => {
    const regex = new RegExp(/^[a-zA-Z0-9][a-zA-Z0-9 _-]+$/);
    return (value: string) => !!regex.exec(value);
});
export interface DatasetUpdateRequest {
    /**
     *
     * #type string
     * #memberof DatasetUpdateRequest
        
        
    * @pattern_DatasetUpdateRequest_name
    * @minLength 3
         */
    name: string;
}
/**
 * Check if a given object implements the DatasetUpdateRequest interface.
 */
export function instanceOfDatasetUpdateRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const DatasetUpdateRequestTypiaAssertEquals = (input: any) => {
    return ((input: any): DatasetUpdateRequest => {
        const __is = (input: any, _exceptionable: boolean = true): input is DatasetUpdateRequest => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.name && 3 <= input.name.length && $is_custom("pattern_DatasetUpdateRequest_name", "string", "", input.name) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasetUpdateRequest => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.name && (3 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 3)",
                    value: input.name
                })) && ($is_custom("pattern_DatasetUpdateRequest_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_DatasetUpdateRequest_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasetUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasetUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const DatasetUpdateRequestTypiaAssertStringify = (input: DatasetUpdateRequest): string => {
    return ((input: any): string => { const assert = (input: any): DatasetUpdateRequest => {
        const __is = (input: any): input is DatasetUpdateRequest => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).name && 3 <= (input as any).name.length && $is_custom("pattern_DatasetUpdateRequest_name", "string", "", (input as any).name));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is DatasetUpdateRequest => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "string" === typeof input.name && (3 <= input.name.length || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@minLength 3)",
                    value: input.name
                })) && ($is_custom("pattern_DatasetUpdateRequest_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_DatasetUpdateRequest_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "DatasetUpdateRequest",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "DatasetUpdateRequest",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: DatasetUpdateRequest): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"name":${$string((input as any).name)}}`;
    }; return stringify(assert(input)); })(input);
};
export const DatasetUpdateRequestValidatorShape = {
    'name': yup.string().matches(/^[a-zA-Z0-9][a-zA-Z0-9 _-]+$/).min(3).defined(),
};
export const DatasetUpdateRequestValidator = yup.object().shape(DatasetUpdateRequestValidatorShape);
export const DatasetUpdateRequestStringifyShapeProperties: ObjectSchema['properties'] = {
    'name': {
        'type': 'string',
        'pattern': "/^[a-zA-Z0-9][a-zA-Z0-9 _-]+$/".slice(1, -1),
        'minLength': 3,
    } as unknown as fastJSON.StringSchema,
};
export const DatasetUpdateRequestStringifyShape: ObjectSchema = {
    title: 'DatasetUpdateRequest Stringifier',
    type: 'object',
    properties: {
        ...DatasetUpdateRequestStringifyShapeProperties
    },
    required: [
        'name',
    ],
};
export const DatasetUpdateRequestStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(DatasetUpdateRequestStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const DatasetUpdateRequestStringify: (data: DatasetUpdateRequest) => string = DatasetUpdateRequestStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function DatasetUpdateRequestFromJSON(json: any): DatasetUpdateRequest {
    return DatasetUpdateRequestFromJSONTyped(json, false);
}
export function DatasetUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetUpdateRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'name': json['name'],
    };
}
export function DatasetUpdateRequestToJSON(value?: DatasetUpdateRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
    };
}
